import { IconButton, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import { toast } from "react-toastify";

let userToken = localStorage.getItem("userToken");

export default function EditHelpCenterItem({ data, setData, itemToEdit, setItemToEdit }) {
  const { index, idx } = itemToEdit;

  const [input, setInput] = useState({
    title: "",
    icon: "",
    faqs: [{ q: "", a: "" }],
    vids: [""],
  });

  const fileInputRef = useRef();

  const ref = useRef();

  useEffect(() => {
    if (Object.keys(itemToEdit).length > 0) {
      setInput(data[index]?.menu[idx]);
    }
  }, [itemToEdit]);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setItemToEdit({});
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAddFAQ = () => {
    let inputDocs = { ...input };
    let faqsDocs = [...input.faqs];

    faqsDocs.push({ q: "", a: "" });

    inputDocs.faqs = faqsDocs;

    setInput(inputDocs);
  };

  const removeQuestion = (indx) => {
    let inputDocs = { ...input };
    let faqsDocs = [...input.faqs];

    let filtered = faqsDocs.filter((_, i) => i !== indx);

    inputDocs.faqs = filtered;

    setInput(inputDocs);
  };

  const handleAddVid = () => {
    let inputDocs = { ...input };
    let vidsDocs = [...input.vids];

    vidsDocs.push("");

    inputDocs.vids = vidsDocs;

    setInput(inputDocs);
  };

  const removeVid = (indx) => {
    let inputDocs = { ...input };
    let vidsDocs = [...input.vids];

    let filtered = vidsDocs.filter((_, i) => i !== indx);

    inputDocs.vids = filtered;

    setInput(inputDocs);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput((prevInput) => ({
      ...prevInput,
      [name]: value,
    }));
  };

  const handleFAQChange = (indx, field, value) => {
    const updatedFAQs = input.faqs.map((faq, i) => (i === indx ? { ...faq, [field]: value } : faq));
    setInput((prevInput) => ({
      ...prevInput,
      faqs: updatedFAQs,
    }));
  };

  const handleIconInput = (e) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        setInput({ ...input, icon: iconURL });
      });
    }
  };

  const saveChanges = () => {
    let dataDocs = [...data];

    dataDocs[index] = {
      ...dataDocs[index],
      menu: [...dataDocs[index].menu.slice(0, idx), input, ...dataDocs[index].menu.slice(idx + 1)],
    };

  

    fetch(`${API}/help-center`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { importantTopics: dataDocs },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setData(dataDocs);
        setInput({
          title: "",
          icon: "",
          faqs: [{ q: "", a: "" }],
          vids: [""],
        });
        setItemToEdit({});
        toast("Updated Successfully", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "success",
        });
      }
    });
 
  };

  return (
    <div
      style={{
        backgroundColor: "#00000020",
        position: "fixed",
        width: "100vw",
        height: "100vh",
        zIndex: 99999999,
        top: 0,
        left: 0,
        opacity: Object.keys(itemToEdit).length > 0 ? 1 : 0,
        visibility: Object.keys(itemToEdit).length > 0 ? "visible" : "hidden",
        transition: "0.3s",
      }}
      className="flex">
      <div
        ref={ref}
        style={{
          width: "70%",
          minWidth: 880,
          height: 560,
          backgroundColor: "#fff",
          borderRadius: 15,
          transition: "0.3s",
          padding: 15,
        }}>
        <div className="flex" style={{ gap: 20, alignItems: "center", height: "90%" }}>
          <div
            className="help-side-b"
            style={{ width: "45%", maxHeight: 400, overflowY: "scroll", paddingRight: 5 }}>
            <p>Label</p>
            <TextField
              label="Label"
              variant="outlined"
              size="small"
              name="title"
              value={input.title || ""}
              onChange={handleInputChange}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 7,
                marginTop: 3,
                width: "90%",
                marginBottom: 20,
              }}>
              <p
                style={{
                  margin: 0,
                }}>
                Icon
              </p>
              <img
                style={{
                  width: 30,
                  aspectRatio: 1,
                  borderRadius: 50,
                  objectFit: "cover",
                }}
                src={input.icon && SERVER_DOMAIN + input.icon}
              />
              <input ref={fileInputRef} type="file" accept="image/*" onChange={handleIconInput} />
            </div>
            <p>YouTube Video Links</p>
            {input.vids?.map((itm, indx) => (
              <div>
                <TextField
                  key={indx}
                  label={"Video Link " + (indx + 1)}
                  variant="outlined"
                  size="small"
                  value={input.vids[indx] || ""}
                  onChange={(e) => {
                    const newVids = [...input.vids];
                    newVids[indx] = e.target.value;

                    setInput({ ...input, vids: newVids });
                  }}
                />

                <IconButton style={{ marginLeft: 5 }} onClick={() => removeVid(index, indx)}>
                  <ClearIcon sx={{ color: "red" }} />
                </IconButton>
              </div>
            ))}

            <div
              className="flex"
              style={{
                backgroundColor: "var(--green)",
                borderRadius: 5,
                color: "#fff",
                width: "50%",
                margin: "5px 0",
                height: 35,
                minHeight: 35,
                cursor: "pointer",
              }}
              key={index}
              onClick={() => handleAddVid(index)}>
              Add New Video
            </div>
          </div>
          <div
            className="help-side-a"
            style={{
              width: "55%",
              maxHeight: 400,
              overflowY: "scroll",
              paddingRight: 5,
            }}>
            <p>FAQs</p>
            {input.faqs.map((itm, indx) => (
              <div key={indx} style={{ marginTop: 35 }}>
                <TextField
                  sx={{ width: "87%" }}
                  label={`Question ${indx + 1}`}
                  variant="outlined"
                  size="small"
                  value={itm.q || ""}
                  onChange={(e) => handleFAQChange(indx, "q", e.target.value)}
                />

                <IconButton style={{ marginLeft: 5 }} onClick={() => removeQuestion(indx)}>
                  <ClearIcon sx={{ color: "red" }} />
                </IconButton>

                <TextField
                  sx={{ width: "95%", mt: 2 }}
                  label={`Answer ${indx + 1}`}
                  variant="outlined"
                  size="small"
                  multiline
                  minRows={3}
                  maxRows={15}
                  value={itm.a || ""}
                  onChange={(e) => handleFAQChange(indx, "a", e.target.value)}
                />
              </div>
            ))}
            <div
              className="flex"
              style={{
                backgroundColor: "var(--green)",
                borderRadius: 5,
                color: "#fff",
                width: "25%",
                margin: "5px 0",
                height: 35,
                cursor: "pointer",
              }}
              key={index}
              onClick={() => handleAddFAQ(index)}>
              Add New
            </div>
          </div>
        </div>

        <div className="submitBTN" style={{ margin: "0 auto", marginTop: 0 }} onClick={saveChanges}>
          Save Changes
        </div>
      </div>
    </div>
  );
}
